import { render, staticRenderFns } from "./WheelsSvgIcon.vue?vue&type=template&id=cd34970a&scoped=true"
import script from "./WheelsSvgIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsSvgIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsSvgIcon.vue?vue&type=style&index=0&id=cd34970a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd34970a",
  null
  
)

export default component.exports